// src/components/admin/Contacts.tsx
import React from "react";
import Messages from "./Messages";

/**
 * お問い合わせ管理ページ
 * 旧チャットUI(ContactThread)ではなく、
 * 新しい Messages レイアウトをそのまま表示する薄いラッパー。
 */
const Contacts: React.FC = () => {
  return <Messages />;
};

export default Contacts;
